module.exports = __webpack_public_path__ + "assets/37ee3b5201ae2e2dc5dc8b1b20ad900e.js";